import styled from "styled-components";

export const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 100%;
  position: relative;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
